import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = ["data-testid"]
const _hoisted_2 = ["data-testid"]
const _hoisted_3 = ["data-testid"]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "flex-1" }, null, -1)
const _hoisted_5 = ["data-testid"]
const _hoisted_6 = ["data-testid", "onClick"]
const _hoisted_7 = ["data-testid"]

import { computed } from 'vue'

import type { QueueBulkAction } from './types'


export default /*#__PURE__*/_defineComponent({
  __name: 'QueueBulkBar',
  props: {
    selectedCount: {},
    pendingCount: {},
    pendingLabel: {},
    primaryLabel: {},
    actions: { default: () => [] },
    clearLabel: { default: 'Limpar' },
    testId: { default: 'queue-bulk-bar' }
  },
  emits: ["primary", "action", "clear"],
  setup(__props: any, { emit }) {

const props = __props;





const selectedLabel = computed(
  () => `${props.selectedCount} ${props.selectedCount > 1 ? 'selecionados' : 'selecionado'}`
)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "sticky bottom-[calc(10px+env(safe-area-inset-bottom,0px))] z-[5] flex flex-wrap items-center gap-x-3 gap-y-2 rounded-[10px] bg-textPrimary px-3.5 py-2.5 text-white shadow-lg",
    "data-testid": _ctx.testId
  }, [
    (_ctx.selectedCount > 0)
      ? (_openBlock(), _createElementBlock("b", {
          key: 0,
          "data-testid": `${_ctx.testId}-selected`
        }, _toDisplayString(selectedLabel.value), 9, _hoisted_2))
      : (_openBlock(), _createElementBlock("span", {
          key: 1,
          "data-testid": `${_ctx.testId}-pending`
        }, [
          _createElementVNode("b", null, _toDisplayString(_ctx.pendingCount), 1),
          _createTextVNode(" " + _toDisplayString(_ctx.pendingLabel) + " neste filtro ", 1)
        ], 8, _hoisted_3)),
    _hoisted_4,
    _createElementVNode("button", {
      type: "button",
      class: "rounded-md border border-primary bg-primary px-3 py-1.5 text-sm font-medium text-white",
      "data-testid": `${_ctx.testId}-primary`,
      onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('primary')))
    }, _toDisplayString(_ctx.primaryLabel), 9, _hoisted_5),
    (_ctx.selectedCount > 0)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.actions, (action) => {
            return (_openBlock(), _createElementBlock("button", {
              key: action.key,
              type: "button",
              class: "rounded-md border border-neutral50 bg-transparent px-3 py-1.5 text-sm font-medium text-white",
              "data-testid": `${_ctx.testId}-action-${action.key}`,
              onClick: ($event: any) => (emit('action', action.key))
            }, _toDisplayString(action.label), 9, _hoisted_6))
          }), 128)),
          _createElementVNode("button", {
            type: "button",
            class: "rounded-md border border-neutral50 bg-transparent px-3 py-1.5 text-sm font-medium text-white",
            "data-testid": `${_ctx.testId}-clear`,
            onClick: _cache[1] || (_cache[1] = ($event: any) => (emit('clear')))
          }, _toDisplayString(_ctx.clearLabel), 9, _hoisted_7)
        ], 64))
      : _createCommentVNode("", true)
  ], 8, _hoisted_1))
}
}

})